import React from 'react';
import { motion } from 'framer-motion';
import { projects } from '../data/projects';

const ProjectsContent = () => (
  <div className="projects-content">
    <h2>{'// projects.exe'}</h2>
    <div className="projects-grid">
      {projects.map((proj, i) => (
        <motion.a
          key={i}
          href={proj.link}
          target="_blank"
          rel="noopener noreferrer"
          className="project-card"
          whileHover={{ scale: 1.02, y: -5 }}
        >
          <div className="project-header">
            <h3>{proj.name}</h3>
            <span className="project-link">↗</span>
          </div>
          <p>{proj.description}</p>
          <div className="project-tech">
            {proj.tech.map(t => <span key={t}>{t}</span>)}
          </div>
        </motion.a>
      ))}
    </div>
  </div>
);

export default ProjectsContent;
